/**
 * 面试官头像组件 ——
 *   - 有图(URL / 上传路径)→ 渲染 <img>
 *   - 没图 → 蓝底圆形 + 白色姓名首字
 */

interface AvatarProps {
  value?: string | null;          // 头像 URL/path,空则走默认
  name?: string | null;           // 姓名(用于取首字),无则用 "?"
  size?: number;
}

const DEFAULT_BG = '#3b82f6';  // 默认蓝(accent-hover)

function isImageSrc(v: string): boolean {
  return v.startsWith('http://') || v.startsWith('https://') || v.startsWith('/');
}

function getInitial(name?: string | null): string {
  if (!name) return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';
  // 中文取首字,英文取首字母
  return trimmed[0].toUpperCase();
}

export function Avatar({ value, name, size = 40 }: AvatarProps) {
  const v = (value || '').trim();

  if (v && isImageSrc(v)) {
    return (
      <img
        src={v}
        alt={name || '头像'}
        style={{
          width: size, height: size, borderRadius: '50%',
          objectFit: 'cover',
          background: DEFAULT_BG,
          flexShrink: 0,
        }}
      />
    );
  }

  // 默认:蓝底白字,姓名首字
  return (
    <span
      style={{
        width: size, height: size, borderRadius: '50%',
        background: DEFAULT_BG,
        color: '#ffffff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.45,
        fontWeight: 600,
        lineHeight: 1,
        flexShrink: 0,
        userSelect: 'none',
        fontFamily: '-apple-system, "PingFang SC", system-ui, sans-serif',
      }}
    >
      {getInitial(name)}
    </span>
  );
}
